export default __webpack_public_path__ + "c6a767f6b40df951eeb9f769914a385a.svg";